import { Component, OnInit } from '@angular/core';
import { SpinnerService } from './../services/spinner.service';
import { environment } from 'src/environments/environment';
import { PrintGroupModel } from '../models/product.printgroup.model';
import { PrintgroupService } from '../services/printgroup.service';

@Component({
  selector: 'app-data-insert',
  templateUrl: './data-insert.component.html',
  styleUrls: ['./data-insert.component.css']
})
export class DataInsertComponent implements OnInit {

  baseUrl = environment.baseUrl;

  constructor(public productCategoryService: PrintgroupService, private spinner: SpinnerService) { 
    const items = { ...localStorage };
  }

  ngOnInit(): void {
    this.spinner.showSpinner();
    
  }

  DBActivity(strcmd:string)
  {
    var i= this.productCategoryService.dataInsert(strcmd).subscribe((data:any)=>{
   // console.log(i);
     });
      this.spinner.hideSpinner();
  }

}
